namespace TabAurous.Stock {
    export namespace StockReportService {
        export const baseUrl = 'Stock/StockReport';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<StockReportRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ProductCodeList(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<StockReportRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Stock/StockReport/List",
            ProductCodeList = "Stock/StockReport/ProductCodeList"
        }

        [
            'List', 
            'ProductCodeList'
        ].forEach(x => {
            (<any>StockReportService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
